<template>
    <main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
      <!--=====================================
           Contact Page Header Section
      ======================================-->
      <section class="pt-[120px] md:pt-[180px] pb-20 sm:pb-32 md:pb-36 lg:pb-36 xl:pb-[100px] relative overflow-hidden">
        <!-- Gradient Background -->
        <div id="hero-gradient-wrapper" class="absolute w-[44%] lg:w-[40%] h-[44%] lg:h-[40%] top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 -z-10 blur-[60px] max-sm:scale-125 md:scale-[0.72]">
          <img src="images/hero-gradient-background.png" alt="hero-gradient-background" id="hero-gradient" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
        </div>
    
        <!-- Header Content -->
        <div class="container">
          <div class="text-center reveal-me">
            <div class="rv-badge">
              <span class="rv-badge-text">Contact</span>
            </div>
            <h1 class="mt-3 lg:mt-8 mb-4 md:mb-7">Your Vision, Our Expertise</h1>
            <p>Tell us what you’re looking for, and let’s make it a reality. Whether it’s a sleek no-code website, a bold digital strategy, or a custom-built solution, we’re here to bring your vision to life. Fill out the form, and let’s get started.</p>
          </div>
        </div>
      </section>
    
      <!--=====================================
          Contact Form Section
      ======================================-->
      <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
        <div class="container">
          <!-- Contact Form -->
          <form class="grid grid-cols-1 md:grid-cols-2 gap-[30px] max-w-[800px] mx-auto reveal-me" method="post" action="https://formspree.io/f/xjkbweyd" name="contactform" id="contactform">
            <!-- Full Name Field (now half width) -->
            <div>
              <label for="name" class="text-2xl leading-[1.2] tracking-[-0.48px] text-[#000000b3] dark:text-dark-100">
                Full Name
              </label>
              <input data-hj-allow type="text" name="name" placeholder="Enter your full name" class="py-4 pl-5 bg-white dark:bg-dark focus:outline-none focus:border-primary border dark:border-dark w-full text-colorText text-xl leading-[1.4] tracking-[0.4px] mt-3" />
            </div>
    
            <!-- Company Field (next to Full Name) -->
            <div>
              <label for="company" class="text-2xl leading-[1.2] tracking-[-0.48px] text-[#000000b3] dark:text-dark-100">
                Company Name
              </label>
              <input data-hj-allow type="text" name="company" placeholder="Your company name" class="py-4 pl-5 bg-white dark:bg-dark focus:outline-none focus:border-primary border dark:border-dark w-full text-colorText text-xl leading-[1.4] tracking-[0.4px] mt-3" />
            </div>
    
            <!-- Email Field -->
            <div>
              <label for="email" class="text-2xl leading-[1.2] tracking-[-0.48px] text-[#000000b3] dark:text-dark-100">
                Work Email
              </label>
              <input data-hj-allow type="email" name="email" placeholder="name@company.com" class="py-4 pl-5 bg-white dark:bg-dark focus:outline-none focus:border-primary border dark:border-dark w-full text-colorText text-xl leading-[1.4] tracking-[0.4px] mt-3" />
            </div>
    
            <!-- Phone Number Field -->
            <div>
              <label for="phone" class="text-2xl leading-[1.2] tracking-[-0.48px] text-[#000000b3] dark:text-dark-100">
                Phone Number
              </label>
              <input data-hj-allow type="tel" name="phone" placeholder="Enter your phone number" class="py-4 pl-5 bg-white dark:bg-dark focus:outline-none focus:border-primary border dark:border-dark w-full text-colorText text-xl leading-[1.4] tracking-[0.4px] mt-3" />
            </div>
    
            <!-- Project Details -->
            <div class="md:col-span-full">
              <label for="Message" class="text-2xl leading-[1.2] tracking-[-0.48px] text-[#000000b3] dark:text-dark-100">
                Project Description
              </label>
              <textarea data-hj-allow name="Message" placeholder="Tell us about your project goals and timeline" class="py-4 pl-5 bg-white dark:bg-dark focus:outline-none focus:border-primary border dark:border-dark w-full text-colorText text-xl leading-[1.4] tracking-[0.4px] mt-3"></textarea>
            </div>
    
            <!-- Submit Button -->
            <div class="col-span-full mx-auto sm:mt-14">
              <button type="submit" class="rv-button rv-button-primary" id="submit-btn">
                <div class="rv-button-top">
                  <span>Send Message</span>
                </div>
                <div class="rv-button-bottom">
                  <span>Send Message</span>
                </div>
              </button>
              <span style="font-size: 18px;display: none;" id="message-success">Message sent successfully, We will reach out shortly!</span>
            </div>
          </form>
        </div>
      </section>
    </main>
    <!--=====================================
       Footer Section
    ======================================-->
    <FooterComponent/>  
    </template>
    
    <script>

    /* global dataLayer, grecaptcha */
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-unused-vars
    const gtag = (...args) => dataLayer.push(args);
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', 'AW-16991041055');
    
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': 'AW-16991041055/X6RKCIrJjrgaEJ_s-qU_',
        'event_callback': callback
      });
      return false;
    }
    
    import FooterComponent from '@/components/FooterComponent.vue'
    import Swal from 'sweetalert2';
    import Cookies from 'js-cookie'

    export default {
      name: 'ContactPage',
      components: {
        FooterComponent,
      },
      methods: {
        submitForm: function(event) {
          event.preventDefault(); // Prevent default behavior
          const button = document.getElementById("submit-btn");
          const messageSpan = document.querySelector("#message-success");
          const form = event.target; 
          // Execute the recaptcha
          grecaptcha.ready(function () {
            grecaptcha.execute('6LelfxcrAAAAADH6E7m0DlHDlZ1uA41zs15ZPp62', { action: 'submit' })
            .then(function (token) {
              const payload = {
                token,
                name:   form.querySelector('input[name="name"]').value.trim(),
                company:form.querySelector('input[name="company"]').value.trim(),
                email:  form.querySelector('input[name="email"]').value.trim(),
                phone:  form.querySelector('input[name="phone"]').value.trim(),
                message:form.querySelector('textarea[name="Message"]').value.trim(),
                page_variant: Cookies.get('webDevVariant') || 'default'

              };
              // Verify the recaptcha token on backend
              fetch('https://api.pairboard.com/neue/verify-captcha', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
              })
              .then(res => res.json())
              .then(function (data) {
                if (data.success) {
                  const form = button.closest("form");
                  if (form) {
                    // Validate Full Name
                    const nameInput = form.querySelector('input[name="name"]');
                    if (!nameInput.value.trim()) {
                      let errorMsg = nameInput.parentNode.querySelector('.name-error');
                      if (!errorMsg) {
                        errorMsg = document.createElement("div");
                        errorMsg.className = "name-error";
                        errorMsg.style.color = "red";
                        errorMsg.style.fontSize = "0.9em";
                        errorMsg.style.marginTop = "5px";
                        errorMsg.textContent = "Please enter your full name!";
                        nameInput.parentNode.appendChild(errorMsg);
                      } else {
                        errorMsg.textContent = "Please enter your full name!";
                      }
                      errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
                      nameInput.focus();
                      return;
                    } else {
                      let errorMsg = nameInput.parentNode.querySelector('.name-error');
                      if (errorMsg) errorMsg.remove();
                    }
    
                    // Validate Company Name
                    const companyInput = form.querySelector('input[name="company"]');
                    if (!companyInput.value.trim()) {
                      let errorMsg = companyInput.parentNode.querySelector('.company-error');
                      if (!errorMsg) {
                        errorMsg = document.createElement("div");
                        errorMsg.className = "company-error";
                        errorMsg.style.color = "red";
                        errorMsg.style.fontSize = "0.9em";
                        errorMsg.style.marginTop = "5px";
                        errorMsg.textContent = "Please enter your company name!";
                        companyInput.parentNode.appendChild(errorMsg);
                      } else {
                        errorMsg.textContent = "Please enter your company name!";
                      }
                      errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
                      companyInput.focus();
                      return;
                    } else {
                      let errorMsg = companyInput.parentNode.querySelector('.company-error');
                      if (errorMsg) errorMsg.remove();
                    }
    
                    // Validate Email
                    const emailInput = form.querySelector('input[name="email"]');
                    const emailValue = emailInput.value.trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    let emailError = form.querySelector(".email-error");
                    if (!emailRegex.test(emailValue)) {
                      if (!emailError) {
                        emailError = document.createElement("div");
                        emailError.className = "email-error";
                        emailError.style.color = "red";
                        emailError.style.fontSize = "0.9em";
                        emailError.style.marginTop = "5px";
                        emailError.textContent = "Please enter a valid email address!";
                        emailInput.parentNode.appendChild(emailError);
                      } else {
                        emailError.textContent = "Please enter a valid email address!";
                      }
                      emailError.scrollIntoView({ behavior: "smooth", block: "center" });
                      emailInput.focus();
                      return;
                    } else if (emailError) {
                      emailError.remove();
                    }
    
                    // Validate Phone Number
                    const phoneInput = form.querySelector('input[name="phone"]');
                    if (!phoneInput.value.trim()) {
                      let errorMsg = phoneInput.parentNode.querySelector('.phone-error');
                      if (!errorMsg) {
                        errorMsg = document.createElement("div");
                        errorMsg.className = "phone-error";
                        errorMsg.style.color = "red";
                        errorMsg.style.fontSize = "0.9em";
                        errorMsg.style.marginTop = "5px";
                        errorMsg.textContent = "Please enter your phone number!";
                        phoneInput.parentNode.appendChild(errorMsg);
                      } else {
                        errorMsg.textContent = "Please enter your phone number!";
                      }
                      errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
                      phoneInput.focus();
                      return;
                    } else {
                      let errorMsg = phoneInput.parentNode.querySelector('.phone-error');
                      if (errorMsg) errorMsg.remove();
                    }
    
                    // Validate Project Description
                    const messageInput = form.querySelector('textarea[name="Message"]');
                    if (!messageInput.value.trim()) {
                      let errorMsg = messageInput.parentNode.querySelector('.message-error');
                      if (!errorMsg) {
                        errorMsg = document.createElement("div");
                        errorMsg.className = "message-error";
                        errorMsg.style.color = "red";
                        errorMsg.style.fontSize = "0.9em";
                        errorMsg.style.marginTop = "5px";
                        errorMsg.textContent = "Please describe your project!";
                        messageInput.parentNode.appendChild(errorMsg);
                      } else {
                        errorMsg.textContent = "Please describe your project!";
                      }
                      errorMsg.scrollIntoView({ behavior: "smooth", block: "center" });
                      messageInput.focus();
                      return;
                    } else {
                      let errorMsg = messageInput.parentNode.querySelector('.message-error');
                      if (errorMsg) errorMsg.remove();
                    }
    
                    // All clear – submit the form via Formspree
                    const formData = new FormData(form);
                    fetch(form.action, {
                      method: form.method || "POST",
                      body: formData,
                      mode: "no-cors"
                    })
                    .then(function () {
                      console.log("Form submitted (opaque response).");
                      gtag_report_conversion();
                      button.style.display = "none";
                      if (messageSpan) messageSpan.style.display = "inline";
                    })
                    .catch(function (error) {
                      console.error("Error:", error);
                    });
                  } // End if (form)
                } else {
                  console.error("Captcha verification failed", data);
                  Swal.fire({
                    icon: "error",
                    title: "Captcha Error",
                    text: "Captcha verification failed. Please try again.",
                  });
                }
              })
              .catch(function (error) {
                console.error("Captcha check error:", error);
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Something went wrong with captcha verification.",
                  customClass: {
                    confirmButton: 'styled-confirm-button'
                  }
                });
              });
            }); // End grecaptcha.execute then
          }); // End grecaptcha.ready
        }
      },
      mounted() {
        const form = document.getElementById("contactform");
        if(form) {
          form.addEventListener('submit', this.submitForm);
        }
      }
    }
    </script>
    
    <style scoped>
      .styled-confirm-button{
        color: black;
        background-color: #83f6b8;
        border: none;
      }
    </style>
    